import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Field, Input, Checkbox, SubmitButton, ErrorBanner, CommonIdentityFields
} from "@/components/auth/FormPrimitives";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/utils/api";
import { consumePostAuthRedirect } from "@/utils/postAuthRedirect";

export default function DoctorSignupForm() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [values, setValues] = useState({
    full_name: "", email: "", phone: "", password: "",
    country: "India", timezone: "Asia/Kolkata",
    specialty: "", license_number: "",
    accept_terms: false, accept_privacy: false,
  });
  const set = (k, v) => setValues((p) => ({ ...p, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signup("doctor", values);
      navigate(consumePostAuthRedirect(), { replace: true });
    } catch (e2) {
      setError(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="doctor-signup-form">
      <CommonIdentityFields values={values} onChange={set} testidPrefix="doctor-signup" />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="Specialty" htmlFor="doctor-specialty">
          <Input
            id="doctor-specialty"
            testid="doctor-specialty"
            value={values.specialty}
            onChange={(e) => set("specialty", e.target.value)}
            placeholder="Pediatrics"
          />
        </Field>
        <Field label="License number" htmlFor="doctor-license">
          <Input
            id="doctor-license"
            testid="doctor-license"
            value={values.license_number}
            onChange={(e) => set("license_number", e.target.value)}
            placeholder="Medical council registration ID"
          />
        </Field>
      </div>

      <div className="pt-2 space-y-2">
        <Checkbox
          testid="doctor-accept-terms"
          checked={values.accept_terms}
          onChange={(e) => set("accept_terms", e.target.checked)}
        >
          I agree to the <a href="/terms" target="_blank" className="text-sky-400 hover:underline">Terms of Service</a>
        </Checkbox>
        <Checkbox
          testid="doctor-accept-privacy"
          checked={values.accept_privacy}
          onChange={(e) => set("accept_privacy", e.target.checked)}
        >
          I have read the <a href="/privacy" target="_blank" className="text-sky-400 hover:underline">Privacy Policy</a>
        </Checkbox>
      </div>

      <ErrorBanner error={error} />
      <SubmitButton loading={loading} testid="doctor-signup-submit">Create Doctor account</SubmitButton>
    </form>
  );
}
